import { createContext } from "react";
import { IUserContext } from "./UserContextInterfaces";
import { isTokenAvailable, getUser } from "../../utilities/storageUtilities";

const currentToken = isTokenAvailable();

export const initialState: IUserContext = {
    user_id: getUser(),
    tokenAvailable: currentToken,
    handleTokenAvailable: () => {},
    handleUserId: () => {},
};

export const UserContext = createContext(initialState);
